var _rect, _rect2, _g, _rect3, _rect4, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallEnd(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "#DDDDDD"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Dailer - Contacts (add/remove/view) and account details",
    clipPath: "url(#clip0_303_2)"
  }, _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 2350,
    height: 2258,
    transform: "translate(-804 -1275)",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Rectangle 294",
    filter: "url(#filter0_d_303_2)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: -146,
    y: -331,
    width: 318,
    height: 444,
    rx: 12,
    fill: "white"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 297",
    x: -122,
    y: -5,
    width: 270,
    height: 36,
    rx: 18,
    fill: "#F8153B"
  })), /*#__PURE__*/React.createElement("g", {
    id: "call_end"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_303_2",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 26,
    height: 26
  }, _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    y: 0.271484,
    width: 25.4559,
    height: 25.4559,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_303_2)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "call_end_2",
    d: "M12.728 8.75684C14.814 8.75684 16.869 9.17668 18.8931 10.0164C20.9172 10.8561 22.7159 12.1156 24.2892 13.795C24.5014 14.0071 24.6074 14.2546 24.6074 14.5374C24.6074 14.8203 24.5014 15.0678 24.2892 15.2799L21.8497 17.6664C21.6553 17.8608 21.4299 17.9669 21.1735 17.9846C20.9172 18.0023 20.683 17.9316 20.4709 17.7725L17.3949 15.439C17.2535 15.3329 17.1475 15.2092 17.0767 15.0678C17.006 14.9263 16.9707 14.7672 16.9707 14.5905V11.5676C16.2989 11.3555 15.6095 11.1875 14.9024 11.0638C14.1953 10.94 13.4705 10.8782 12.728 10.8782C11.9856 10.8782 11.2608 10.94 10.5537 11.0638C9.84657 11.1875 9.15714 11.3555 8.48539 11.5676V14.5905C8.48539 14.7672 8.45004 14.9263 8.37933 15.0678C8.30861 15.2092 8.20255 15.3329 8.06113 15.439L4.98521 17.7725C4.77308 17.9316 4.53885 18.0023 4.28252 17.9846C4.0262 17.9669 3.80081 17.8608 3.60635 17.6664L1.16683 15.2799C0.954699 15.0678 0.848633 14.8203 0.848633 14.5374C0.848633 14.2546 0.954699 14.0071 1.16683 13.795C2.72247 12.1156 4.51675 10.8561 6.54969 10.0164C8.58262 9.17668 10.6421 8.75684 12.728 8.75684Z",
    fill: "white"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_303_2",
    x: -150,
    y: -331,
    width: 326,
    height: 452,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_303_2"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_303_2",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_303_2"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2350,
    height: 2258,
    fill: "white",
    transform: "translate(-804 -1275)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallEnd);
export default __webpack_public_path__ + "static/media/call_end.63a6c224fb986d1319e343740e453c3d.svg";
export { ForwardRef as ReactComponent };